module.exports = __webpack_public_path__ + "static/img/feature-mobile.dc4c8c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-mobile.jpg
// module id = LDOw
// module chunks = 0